import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Header from "./header";
import Footer from "./footer";
import Swal from "sweetalert2";
import axios from "axios";

export default function Account() {
  const [user, setUser] = useState(null);
  const [address, setAddress] = useState(null);
  const [userForm, setUserForm] = useState({});
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addressForm, setAddressForm] = useState({});
  const [editAddress, setEditAddress] = useState(false);
  const [editUser, setEditUser] = useState(false);
  const [selectId, setSelectId] = useState(0);
  const history = useHistory();
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("userToken");
      if (!token) {
        Swal.fire(
          "Login Required",
          "Please login to proceed to checkout.",
          "info"
        );
        return;
      }

      try {
        // Fetch user info
        const userRes = await axios.get(
          "https://sunrise-backend.sunrisemeditechsystems.com/api/users/myData",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setUser(userRes.data);
        setUserForm({
          name: userRes.data.name,
          email: userRes.data.email,
          username: userRes.data.username,
          phone: userRes.data.phone,
          area: userRes.data.area,
        });

        // Fetch orders
        const orderRes = await axios.get(
          "https://sunrise-backend.sunrisemeditechsystems.com/api/orders/my-orders",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log("Fetched orders:", orderRes.data);
        setOrders(orderRes.data);
        if (orderRes.data.length > 0) {
          // Use the shipping address from the latest order
          const lastAddress = orderRes.data[0].shipping_address;
          setAddress(lastAddress);
          setAddressForm(lastAddress);
        }
      } catch (err) {
        setUser(null);
        setOrders([]);
      }
      setLoading(false);
    };
    fetchData();
  }, [history]);
  const saveAddress = () => {
    setAddress(addressForm);
    setEditAddress(false);
    // Optionally, send to backend to save as default address
  };
  const handleAddressChange = (e) => {
    setAddressForm({ ...addressForm, [e.target.name]: e.target.value });
  };
  const saveUser = async () => {
    const token = localStorage.getItem("userToken");
    try {
      await axios.put("https://sunrise-backend.sunrisemeditechsystems.com/api/users/myData", userForm, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser({ ...user, ...userForm });
      setEditUser(false);
    } catch (err) {
      // handle error
    }
  };
  const handleUserChange = (e) => {
    setUserForm({ ...userForm, [e.target.name]: e.target.value });
  };
  const handleAccountOrderDetails = (id) => {
    setSelectId(id);
  };
  return (
    <>
      <div className="color-scheme-wrap active">
        <button className="switchIcon">
          <i className="fa-solid fa-palette"></i>
        </button>
        <h4 className="color-scheme-wrap-title">
          <i className="far fa-palette me-2"></i>Style Swicher
        </h4>
        <div className="color-switch-btns">
          <button data-color="#3E66F3">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#684DF4">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#008080">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#323F7C">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#FC3737">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#8a2be2">
            <i className="fa-solid fa-droplet"></i>
          </button>
        </div>
        <Link
          to="https://themeforest.net/user/themeholy"
          className="th-btn text-center w-100"
        >
          <i className="fa fa-shopping-cart me-2"></i> Purchase
        </Link>
      </div>
      {/* Preloader */}
      {/* <div className="preloader ">
        <button className="th-btn preloaderCls">Cancel Preloader </button>
        <div className="preloader-inner">
          <img src="assets/img/logo.svg" alt="img" />
          <div className="heart-rate">
            <img src="assets/img/shape/preloader.svg" alt="" />

            <div className="fade-in"></div>

            <div className="fade-out"></div>
          </div>
        </div>
      </div> */}
      {/* Sidemenu */}
      <div className="sidemenu-wrapper shopping-cart ">
        <div className="sidemenu-content">
          <button className="closeButton sideMenuCls">
            <i className="far fa-times"></i>
          </button>
          <div className="widget woocommerce widget_shopping_cart">
            <h3 className="widget_title">Shopping cart</h3>
            <div className="widget_shopping_cart_content">
              <ul className="woocommerce-mini-cart cart_list product_list_widget ">
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_1.jpg"
                      alt="Cart Image1"
                    />
                    Puregen Labs Meclizine
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $55.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_2.jpg"
                      alt="Cart Image2"
                    />
                    Pranarom Pure Essential Oil
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $15.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_3.jpg"
                      alt="Cart Image3"
                    />
                    Pediatric Stethoscope
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $30.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_4.jpg"
                      alt="Cart Image5"
                    />
                    Puregen Labs Allergy Relief
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $55.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_5.jpg"
                      alt="Cart Image6"
                    />
                    Digital Thermometer
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $15.99
                    </span>
                  </span>
                </li>
              </ul>
              <p className="woocommerce-mini-cart__total total">
                <strong>Subtotal:</strong>
                <span className="woocommerce-Price-amount amount">
                  <span className="woocommerce-Price-currencySymbol">$</span>
                  170.99
                </span>
              </p>
              <p className="woocommerce-mini-cart__buttons buttons btn-wrap">
                <Link to="cart.html" className="th-btn wc-forward">
                  View cart
                </Link>
                <Link to="checkout.html" className="th-btn checkout wc-forward">
                  Checkout
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Sidemenu */}
      <div className="sidemenu-wrapper ">
        <div className="sidemenu-content">
          <button className="closeButton sideMenuCls">
            <i className="far fa-times"></i>
          </button>
          <div className="widget footer-widget mb-0">
            <div className="th-widget-about">
              <div className="about-logo">
                <Link to="index.html">
                  <img src="assets/img/logo.svg" alt="Medova " />
                </Link>
              </div>
              <p className="about-text">
                Medova is a convenience services to the adaptability, Spacious
                modern villa living room with centrally placed swimming pool
                blending indooroutdoor
              </p>
            </div>
          </div>
          <div className="widget footer-widget">
            <h3 className="widget_title">Recent Posts</h3>
            <div className="recent-post-wrap">
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-1.jpg"
                      alt="Blog Image2"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>
                      April 02, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-2.jpg"
                      alt="Blog Image3"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>
                      April 25, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-3.jpg"
                      alt="Blog Image4"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>26
                      April, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-4.jpg"
                      alt="Blog Image5"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>27
                      April, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="widget footer-widget">
            <h3 className="widget_title">Social Media:</h3>
            <div className="th-social">
              <Link to="https://facebook.com">
                <i className="fab fa-facebook-f"></i>
              </Link>
              <Link to="https://twitter.com">
                <i className="fab fa-twitter"></i>
              </Link>
              <Link to="https://pinterest.com">
                <i className="fab fa-pinterest-p"></i>
              </Link>
              <Link to="https://linkedin.com">
                <i className="fab fa-linkedin-in"></i>
              </Link>
              <Link to="https://linkedin.com">
                <i className="fab fa-instagram"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="popup-search-box d-none d-lg-block">
        <button className="searchClose">
          <i className="fal fa-times"></i>
        </button>
        <form action="#">
          <input type="text" placeholder="What are you looking for?" />
          <button type="submit">
            <i className="fal fa-search"></i>
          </button>
        </form>
      </div>
      {/* Mobile Menu */}
      <div className="th-menu-wrapper">
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle">
            <i className="fal fa-times"></i>
          </button>
          <div className="mobile-logo">
            <Link to="home-medical-clinic.html">
              <img src="assets/img/logo.svg" alt="Medova " />
            </Link>
          </div>

          <div className="th-mobile-menu">
            <ul>
              <li className="menu-item-has-children">
                <Link to="home-medical-clinic.html">Home</Link>
                <ul className="sub-menu">
                  <li className="menu-item-has-children">
                    <Link to="#">Multipage</Link>
                    <ul>
                      <li>
                        <Link to="home-medical-clinic.html">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-clinic-v2.html">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care.html">Home Dental Care</Link>
                      </li>
                      <li>
                        <Link to="home-pediatric.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology.html">Home Cardiology</Link>
                      </li>
                      <li>
                        <Link to="home-surgery.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy.html">
                          Home Physiotherapy
                        </Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist.html">Home Optometrist</Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop.html">
                          Home Medical Shop
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to="#">Onepage</Link>
                    <ul>
                      <li>
                        <Link to="home-medical-clinic-op.html">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-clinic-v2-op.html">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care-op.html">
                          Home Dental Care
                        </Link>
                      </li>
                      <li>
                        <Link to="home-pediatric-op.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology-op.html">
                          Home Cardiology
                        </Link>
                      </li>
                      <li>
                        <Link to="home-surgery-op.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy-op.html">
                          Home Physiotherapy
                        </Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet-op.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist-op.html">
                          Home Optometrist
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop-op.html">
                          Home Medical Shop
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="about.html">About Us</Link>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Services</Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="service.html">Services</Link>
                  </li>
                  <li>
                    <Link to="service-details.html">Service Details</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Pages</Link>
                <ul className="sub-menu">
                  <li className="menu-item-has-children">
                    <Link to="#">Shop</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="shop.html">Shop</Link>
                      </li>
                      <li>
                        <Link to="shop-details.html">Shop Details</Link>
                      </li>
                      <li>
                        <Link to="cart.html">Cart Page</Link>
                      </li>
                      <li>
                        <Link to="checkout.html">Checkout</Link>
                      </li>
                      <li>
                        <Link to="wishlist.html">Wishlist</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="doctor.html">Doctors</Link>
                  </li>
                  <li>
                    <Link to="doctor-details.html">Doctors Details</Link>
                  </li>
                  <li>
                    <Link to="case-studies.html">Case Studies</Link>
                  </li>
                  <li>
                    <Link to="case-studies-details.html">
                      Case Studies Details
                    </Link>
                  </li>
                  <li>
                    <Link to="appointment.html">Appointment</Link>
                  </li>
                  <li>
                    <Link to="pricing.html">Price Table</Link>
                  </li>
                  <li>
                    <Link to="error.html">Error Page</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Blog</Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="#">Blog Layout</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="blog.html">Blog</Link>
                      </li>
                      <li>
                        <Link to="blog-grid.html">Blog Grid</Link>
                      </li>
                      <li>
                        <Link to="blog-grid-sidebar.html">
                          Blog Grid With Sidebar
                        </Link>
                      </li>
                      <li>
                        <Link to="blog-list.html">Blog List</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="blog-details.html">Blog Details</Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Header Area */}
      <Header />
      {/* Breadcumb */}
      <div
        className="breadcumb-wrapper "
        data-bg-src="assets/img/bg/breadcumb-bg.jpg"
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Account</h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Account</li>
            </ul>
          </div>
        </div>
      </div>

      <section className="overflow-hidden space">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-3 col-xxl-3">
              <div className="ltn__tab-menu-list mb-50">
                <div className="nav">
                  <Link
                    className="active show"
                    data-bs-toggle="tab"
                    to="#liton_tab_1_1"
                  >
                    Dashboard <i className="fas fa-home" />
                  </Link>
                  <Link data-bs-toggle="tab" to="#liton_tab_1_2">
                    Orders <i className="fas fa-file-alt" />
                  </Link>
                  <Link data-bs-toggle="tab" to="#liton_tab_1_3">
                    Downloads <i className="fas fa-arrow-down" />
                  </Link>
                  <Link data-bs-toggle="tab" to="#liton_tab_1_4">
                    address <i className="fas fa-map-marker-alt" />
                  </Link>
                  <Link data-bs-toggle="tab" to="#liton_tab_1_5">
                    Account Details <i className="fas fa-user" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-9 col-xxl-9">
              <div className="tab-content">
                <div className="tab-pane fade active show" id="liton_tab_1_1">
                  <div className="ltn__myaccount-tab-content-inner">
                    <p>
                      Hello <strong>{user ? user.name : "User"}</strong> (not{" "}
                      <strong>{user ? user.name : "User"}</strong>?{" "}
                      <small>
                        {/* <Link to="/logout" onClick={handleLogout}>
                          Log out
                        </Link> */}
                      </small>{" "}
                      )
                    </p>
                    <p>
                      From your account dashboard you can view your{" "}
                      <span>recent orders</span>, manage your{" "}
                      <span>shipping and billing addresses</span>, and{" "}
                      <span>edit your password and account details</span>.
                    </p>
                  </div>
                </div>
                <div className="tab-pane fade" id="liton_tab_1_2">
                  <form action="#" className="woocommerce-cart-form">
                    <table className="cart_table">
                      <thead>
                        <tr>
                          <th>Order</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th>Total</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orders.map((element, idx) => {
                          return (
                            <tr key={element.id}>
                              <td>{idx + 1}</td>
                              <td>
                                {new Date(
                                  element.created_at
                                ).toLocaleDateString()}
                              </td>
                              <td>{element.status}</td>
                              <td>₹{element.total_amount}</td>
                              <td>
                                <button
                                  className="btn btn-sm btn-outline-info"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#order-details-${element.id}`}
                                  aria-expanded="false"
                                  aria-controls={`order-details-${element.id}`}
                                  onClick={() =>
                                    handleAccountOrderDetails(element.id)
                                  }
                                >
                                  View
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {orders.map((order) => (
                      <>
                        {order.id == selectId && (
                          <div
                            key={`details-${order.id}`}
                            className="card card-body mb-3"
                            style={{ textAlign: "left" }}
                          >
                            <h6>Order Items:</h6>
                            {order.items != [] && (
                              <>
                                <ul>
                                  {order.items.map((item, i) => (
                                    <li key={i}>
                                      {item.name} × {item.quantity} (
                                      {item.buyOrRent}) — ₹
                                      {item.price?.toFixed(2)}
                                    </li>
                                  ))}
                                </ul>
                              </>
                            )}
                            <div>
                              {order.shipping_address &&
                              order.shipping_address.firstName != null ? (
                                <>
                                  <strong>Shipping Address:</strong>
                                  <div>
                                    {order.shipping_address.firstName}{" "}
                                    {order.shipping_address.lastName},<br />
                                    {order.shipping_address.address1},<br />
                                    {order.shipping_address.city},{" "}
                                    {order.shipping_address.state} -{" "}
                                    {order.shipping_address.zip}
                                  </div>
                                </>
                              ) : (
                                <span>
                                  <strong>Shipping Address:</strong> N/A
                                </span>
                              )}
                            </div>

                            <div>
                              <strong>Order Notes:</strong>{" "}
                              {order.shipping_address.notes || "N/A"}
                            </div>
                          </div>
                        )}
                      </>
                    ))}
                  </form>
                </div>
                <div className="tab-pane fade" id="liton_tab_1_3">
                  <form action="#" className="woocommerce-cart-form">
                    <table className="cart_table">
                      <thead>
                        <tr>
                          <th>Product</th>
                          <th>Date</th>
                          <th>Expire</th>
                          <th>Download</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan="4" className="text-center">
                            No downloads available.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </form>
                </div>
                <div className="tab-pane fade" id="liton_tab_1_4">
                  <div className="ltn__myaccount-tab-content-inner">
                    <p>
                      The following addresses will be used on the checkout page
                      by default.
                    </p>
                    <div className="row">
                      <div className="col-md-6 col-12 learts-mb-30">
                        <h4>
                          Shipping Address{" "}
                          <small>
                            <Link to="#" onClick={() => setEditAddress(true)}>
                              edit
                            </Link>
                          </small>
                        </h4>
                        {address ? (
                          editAddress ? (
                            <form
                              onSubmit={(e) => {
                                e.preventDefault();
                                saveAddress();
                              }}
                            >
                              <input
                                type="text"
                                name="firstName"
                                value={addressForm?.firstName || ""}
                                onChange={handleAddressChange}
                                placeholder="First Name"
                              />
                              <input
                                type="text"
                                name="lastName"
                                value={addressForm?.lastName || ""}
                                onChange={handleAddressChange}
                                placeholder="Last Name"
                              />
                              <input
                                type="text"
                                name="address1"
                                value={addressForm?.address1 || ""}
                                onChange={handleAddressChange}
                                placeholder="Address"
                              />
                              <input
                                type="text"
                                name="city"
                                value={addressForm?.city || ""}
                                onChange={handleAddressChange}
                                placeholder="City"
                              />
                              <input
                                type="text"
                                name="state"
                                value={addressForm?.state || ""}
                                onChange={handleAddressChange}
                                placeholder="State"
                              />
                              <input
                                type="text"
                                name="zip"
                                value={addressForm?.zip || ""}
                                onChange={handleAddressChange}
                                placeholder="Zip"
                              />
                              <button
                                type="submit"
                                className="btn theme-btn-1 btn-effect-1 text-uppercase"
                              >
                                Save
                              </button>
                            </form>
                          ) : (
                            <address className="border rounded p-3 bg-light">
                              {address && address.firstName != null ? (
                                <>
                                  <p className="mb-1">
                                    <strong>
                                      {address?.firstName} {address?.lastName}
                                    </strong>
                                  </p>
                                  <p className="mb-0">
                                    {address?.address1} <br />
                                    {address?.city}, {address?.state}{" "}
                                    {address?.zip}
                                  </p>
                                </>
                              ) : (
                                <p>address not found</p>
                              )}
                            </address>
                          )
                        ) : (
                          <div>No address found. Please add your address.</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="liton_tab_1_5">
                  <div className="ltn__myaccount-tab-content-inner">
                    <div className="ltn__form-box">
                      {editUser ? (
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            saveUser();
                          }}
                        >
                          <div className="row mb-50">
                            <div className="col-md-6 mb-3">
                              <label>Name:</label>
                              <input
                                type="text"
                                name="name"
                                value={userForm.name}
                                onChange={handleUserChange}
                              />
                            </div>
                            <div className="col-md-6">
                              <label>Email:</label>
                              <input
                                type="email"
                                name="email"
                                value={userForm.email}
                                onChange={handleUserChange}
                              />
                            </div>
                            <div className="col-md-6 mb-3">
                              <label>Username:</label>
                              <input
                                type="text"
                                name="username"
                                value={userForm.username}
                                onChange={handleUserChange}
                              />
                            </div>
                            <div className="col-md-6">
                              <label>Phone:</label>
                              <input
                                type="text"
                                name="phone"
                                maxLength="10"
                                value={userForm.phone}
                                onChange={handleUserChange}
                              />
                            </div>
                            <div className="col-md-6">
                              <label>Area:</label>
                              <input
                                type="text"
                                name="area"
                                value={userForm.area}
                                onChange={handleUserChange}
                              />
                            </div>
                          </div>

                          <div className="btn-wrapper">
                            <button
                              type="submit"
                              className="btn theme-btn-1 btn-effect-1 text-uppercase"
                            >
                              Save Changes
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary ms-2"
                              onClick={() => setEditUser(false)}
                            >
                              Cancel
                            </button>
                          </div>
                        </form>
                      ) : user ? (
                        <div>
                          <p>
                            <strong>Name:</strong> {user?.name}
                          </p>
                          <p>
                            <strong>Email:</strong> {user?.email}
                          </p>
                          <p>
                            <strong>Username:</strong> {user?.username}
                          </p>
                          <p>
                            <strong>Phone:</strong> {user?.phone}
                          </p>
                          <p>
                            <strong>Area:</strong> {user?.area}
                          </p>
                          <button
                            className="btn theme-btn-1 btn-effect-1 text-uppercase"
                            onClick={() => setEditUser(true)}
                          >
                            Edit
                          </button>
                        </div>
                      ) : (
                        <p>User not found</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-6 col-xxl-3">
                    <div className="price-card th-ani  wow fadeInUp" data-wow-delay=".3s">
                        <div className="box-content">
                            <span className="offer-tag"></span>
                            <h3 className="box-title">Basic Plan123</h3>
                            <h4 className="box-price">$29<span className="duration">/month</span></h4>
                            <p className="box-text">Perfect for occassional care and minor adjustment</p>
                        </div>
                        <div className="available-list">
                            <ul>
                                <li>1 Chiropractic Adjustment</li>
                                <li>Personalized Treatment Advice</li>
                                <li>Follow-Up Recommendations</li>
                                <li>Weekly Check-ins</li>
                                <li>24/7 Customer Support</li>
                                <li>Many More...</li>
                            </ul>
                            <Link to="contact.html" className="th-btn black-border fw-btn">Get Started <i className="fa-regular fa-arrow-right ms-2"></i> </Link>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6 col-xxl-3">
                    <div className="price-card th-ani active wow fadeInUp" data-wow-delay=".5s">
                        <div className="box-content">
                            <span className="offer-tag">45% Off</span>
                            <h3 className="box-title">Stadndard</h3>
                            <h4 className="box-price">$49<span className="duration">/month</span></h4>
                            <p className="box-text">Perfect for occassional care and minor adjustment</p>
                        </div>
                        <div className="available-list">
                            <ul>
                                <li>5 Chiropractic Adjustment</li>
                                <li>Personalized Treatment Advice</li>
                                <li>Follow-Up Recommendations</li>
                                <li>Weekly Check-ins</li>
                                <li>24/7 Customer Support</li>
                                <li>Many More...</li>
                            </ul>
                            <Link to="contact.html" className="th-btn black-border fw-btn">Get Started <i className="fa-regular fa-arrow-right ms-2"></i> </Link>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6 col-xxl-3">
                    <div className="price-card th-ani  wow fadeInUp" data-wow-delay=".7s">
                        <div className="box-content">
                            <span className="offer-tag"></span>
                            <h3 className="box-title">Premium</h3>
                            <h4 className="box-price">$79<span className="duration">/month</span></h4>
                            <p className="box-text">Perfect for occassional care and minor adjustment</p>
                        </div>
                        <div className="available-list">
                            <ul>
                                <li>15 Chiropractic Adjustment</li>
                                <li>Personalized Treatment Advice</li>
                                <li>Follow-Up Recommendations</li>
                                <li>Weekly Check-ins</li>
                                <li>24/7 Customer Support</li>
                                <li>Many More...</li>
                            </ul>
                            <Link to="contact.html" className="th-btn black-border fw-btn">Get Started <i className="fa-regular fa-arrow-right ms-2"></i> </Link>
                        </div>
                    </div>
                </div> */}
          </div>
        </div>
      </section>

      {/* <section className="bg-smoke2 space overflow-hidden">
        <div className="container">
            <div className="title-area text-center">
                <span className="sub-title text-anime-style-2">Pricing Plan</span>
                <h2 className="sec-title text-anime-style-3"><span className="fw-normal">Transparent</span> Pricing Plans</h2>
            </div>
            <div className="row gy-4 justify-content-center align-items-center">
                <div className="col-xl-6">
                    <div className="price-content wow fadeInUp" data-wow-delay=".1s">
                        <div>
                            <span className="subtitle text-anime-style-2">Starting from $258<span className="duration">/year</span></span>
                            <h4 className="box-title text-anime-style-3">Our Dental Care Plan</h4>
                            <p className="box-text">Save thousands while gaining access to the highest quality dental care.</p>
                            <Link to="about.html" className="th-btn style1">Book Now <i className="fa-light fa-arrow-right-long ms-2"></i></Link>
                        </div>
                        <div className="price-shape">
                            <img src="assets/img/shape/element-8.png" alt=""/>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3">
                    <div className="price-item wow fadeInUp" data-wow-delay=".2s">
                        <h3 className="box-title">Wisdom Tooth Extraction</h3>
                        <span className="subtitle">Benefits</span>
                        <div className="btn-group">
                            <Link to="contact.html" className="th-btn black-border">Choose Plan <i className="fa-light fa-arrow-right-long ms-2"></i></Link>

                            <h4 className="box-price"><span className="price"><del>$389</del></span><span className="doller">$</span>258
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3">
                    <div className="price-item wow fadeInUp" data-wow-delay=".3s">
                        <h3 className="box-title">Deep Cleaning (Scaling & Root)</h3>
                        <span className="subtitle">Benefits</span>
                        <div className="btn-group">
                            <Link to="contact.html" className="th-btn black-border">Choose Plan <i className="fa-light fa-arrow-right-long ms-2"></i></Link>

                            <h4 className="box-price"><span className="price"><del>$459</del></span><span className="doller">$</span>359
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3">
                    <div className="price-item wow fadeInUp" data-wow-delay=".4s">
                        <h3 className="box-title">Tooth-Colored <span className="d-block">Fillings</span></h3>
                        <span className="subtitle">Benefits</span>
                        <div className="btn-group">
                            <Link to="contact.html" className="th-btn black-border">Choose Plan <i className="fa-light fa-arrow-right-long ms-2"></i></Link>

                            <h4 className="box-price"><span className="price"><del>$389</del></span><span className="doller">$</span>258
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3">
                    <div className="price-item wow fadeInUp" data-wow-delay=".5s">
                        <h3 className="box-title">Dental Crowns (Porcelain/Metal)</h3>
                        <span className="subtitle">Benefits</span>
                        <div className="btn-group">
                            <Link to="contact.html" className="th-btn black-border">Choose Plan <i className="fa-light fa-arrow-right-long ms-2"></i></Link>

                            <h4 className="box-price"><span className="price"><del>$459</del></span><span className="doller">$</span>359
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3">
                    <div className="price-item wow fadeInUp" data-wow-delay=".6s">
                        <h3 className="box-title">Teeth Whitening <span className="d-block"> (In-Office)</span></h3>
                        <span className="subtitle">Benefits</span>
                        <div className="btn-group">
                            <Link to="contact.html" className="th-btn black-border">Choose Plan <i className="fa-light fa-arrow-right-long ms-2"></i></Link>

                            <h4 className="box-price"><span className="price"><del>$459</del></span><span className="doller">$</span>359
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3">
                    <div className="price-btn wow fadeInUp text-center" data-wow-delay=".7s">
                        <button className="th-btn style2 style-radius">Get Personalized Quote <i className="fa-light fa-arrow-right-long ms-2"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div className="shape-mockup d-none d-xxl-block" data-top="0%" data-right="0%"><img src="assets/img/shape/element-1.png" alt=""/></div>
    </section>
    
    <div className="overflow-hidden space-top overflow-hidden">
        <div className="container">
            <div className="slider-area">
                <div className="swiper th-slider" id="brandSlider1" data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"476":{"slidesPerView":"2"},"768":{"slidesPerView":"2"},"992":{"slidesPerView":"3"},"1200":{"slidesPerView":"4"},"1400":{"slidesPerView":"5"}}}'>
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <div className="brand-item">
                                <Link to="">
                                    <img className="original" src="assets/img/brand/brand_1_1.svg" alt="Brand Logo"/>
                                    <img className="gray" src="assets/img/brand/brand_1_1.svg" alt="Brand Logo"/>
                                </Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-item">
                                <Link to="">
                                    <img className="original" src="assets/img/brand/brand_1_2.svg" alt="Brand Logo"/>
                                    <img className="gray" src="assets/img/brand/brand_1_2.svg" alt="Brand Logo"/>
                                </Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-item">
                                <Link to="">
                                    <img className="original" src="assets/img/brand/brand_1_3.svg" alt="Brand Logo"/>
                                    <img className="gray" src="assets/img/brand/brand_1_3.svg" alt="Brand Logo"/>
                                </Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-item">
                                <Link to="">
                                    <img className="original" src="assets/img/brand/brand_1_4.svg" alt="Brand Logo"/>
                                    <img className="gray" src="assets/img/brand/brand_1_4.svg" alt="Brand Logo"/>
                                </Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-item">
                                <Link to="">
                                    <img className="original" src="assets/img/brand/brand_1_5.svg" alt="Brand Logo"/>
                                    <img className="gray" src="assets/img/brand/brand_1_5.svg" alt="Brand Logo"/>
                                </Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-item">
                                <Link to="">
                                    <img className="original" src="assets/img/brand/brand_1_1.svg" alt="Brand Logo"/>
                                    <img className="gray" src="assets/img/brand/brand_1_1.svg" alt="Brand Logo"/>
                                </Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-item">
                                <Link to="">
                                    <img className="original" src="assets/img/brand/brand_1_2.svg" alt="Brand Logo"/>
                                    <img className="gray" src="assets/img/brand/brand_1_2.svg" alt="Brand Logo"/>
                                </Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-item">
                                <Link to="">
                                    <img className="original" src="assets/img/brand/brand_1_3.svg" alt="Brand Logo"/>
                                    <img className="gray" src="assets/img/brand/brand_1_3.svg" alt="Brand Logo"/>
                                </Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-item">
                                <Link to="">
                                    <img className="original" src="assets/img/brand/brand_1_4.svg" alt="Brand Logo"/>
                                    <img className="gray" src="assets/img/brand/brand_1_4.svg" alt="Brand Logo"/>
                                </Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-item">
                                <Link to="">
                                    <img className="original" src="assets/img/brand/brand_1_5.svg" alt="Brand Logo"/>
                                    <img className="gray" src="assets/img/brand/brand_1_5.svg" alt="Brand Logo"/>
                                </Link>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
   
    <div className="overflow-hidden space overflow-hidden" id="faq-sec">
        <div className="container">
            <div className="faq-area">
                <div className="row align-items-center">
                    <div className="col-xl-5">
                        <div className="opening-hour-content" data-bg-src="assets/img/bg/contact_bg_1.png">
                            <div className="title-area text-center">
                                <h2 className="sec-title text-white text-anime-style-3">Opening Hours</h2>
                                <p className="text wow fadeInUp">Most medical centers offer charity programs, counseling, and financial
                                    assistance for those in need.</p>
                            </div>
                            <div className="times-content">
                                <span className="day">Moday <span className="time">8:00AM - 5:30PM</span></span>
                                <span className="day">Tuesday <span className="time">8:00AM - 5:30PM</span></span>
                                <span className="day">Wednesday <span className="time">8:00AM - 5:30PM</span></span>
                                <span className="day">Thursday <span className="time">8:00AM - 5:30PM</span></span>
                                <span className="day">Friday <span className="time">8:00AM - 5:30PM</span></span>
                                <span className="day">Saturday <span className="time">8:00AM - 5:30PM</span></span>

                            </div>
                            <div className="btn-group mt-60">
                                <Link to="about.html" className="th-btn style1">Book an Appointment <i className="fa-light fa-arrow-right-long ms-2"></i></Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-7 mt-35 mt-xl-0">
                        <div className="faq-content">
                            <div className="title-area mb-40">
                                <span className="sub-title text-anime-style-2">FAQ’S</span>
                                <h2 className="sec-title text-anime-style-3">Frequently Ask <span className="fw-normal">Questions</span></h2>
                            </div>
                            <div className="accordion-area accordion" id="faqAccordion3">



                                <div className="accordion-card  wow fadeInUp" data-wow-delay=".1s">
                                    <div className="accordion-header" id="collapse-item-1">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-1" aria-expanded="false" aria-controls="collapse-1">1. How can I naturally balance my hormones?</button>
                                    </div>
                                    <div id="collapse-1" className="accordion-collapse collapse " aria-labelledby="collapse-item-1" data-bs-parent="#faqAccordion3">
                                        <div className="accordion-body">
                                            <p className="faq-text">Most medical centers offer charity programs, counseling, and
                                                financial assistance for those in need. Non-Muslims are welcome to visit
                                                mosques. They should dress modestly and remove their shoes upon entering.
                                            </p>
                                        </div>
                                    </div>
                                </div>



                                <div className="accordion-card active wow fadeInUp" data-wow-delay=".3s">
                                    <div className="accordion-header" id="collapse-item-2">
                                        <button className="accordion-button " type="button" data-bs-toggle="collapse" data-bs-target="#collapse-2" aria-expanded="true" aria-controls="collapse-2">2. How can I book an appointment for emergency treatment?</button>
                                    </div>
                                    <div id="collapse-2" className="accordion-collapse collapse show" aria-labelledby="collapse-item-2" data-bs-parent="#faqAccordion3">
                                        <div className="accordion-body">
                                            <p className="faq-text">Most medical centers offer charity programs, counseling, and
                                                financial assistance for those in need. Non-Muslims are welcome to visit
                                                mosques. They should dress modestly and remove their shoes upon entering.
                                            </p>
                                        </div>
                                    </div>
                                </div>



                                <div className="accordion-card  wow fadeInUp" data-wow-delay=".5s">
                                    <div className="accordion-header" id="collapse-item-3">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-3" aria-expanded="false" aria-controls="collapse-3">3. Will medical aid pay for the treatment?</button>
                                    </div>
                                    <div id="collapse-3" className="accordion-collapse collapse " aria-labelledby="collapse-item-3" data-bs-parent="#faqAccordion3">
                                        <div className="accordion-body">
                                            <p className="faq-text">Most medical centers offer charity programs, counseling, and
                                                financial assistance for those in need. Non-Muslims are welcome to visit
                                                mosques. They should dress modestly and remove their shoes upon entering.
                                            </p>
                                        </div>
                                    </div>
                                </div>



                                <div className="accordion-card  wow fadeInUp" data-wow-delay=".7s">
                                    <div className="accordion-header" id="collapse-item-4">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-4" aria-expanded="false" aria-controls="collapse-4">4. What programs are available for developer?</button>
                                    </div>
                                    <div id="collapse-4" className="accordion-collapse collapse " aria-labelledby="collapse-item-4" data-bs-parent="#faqAccordion3">
                                        <div className="accordion-body">
                                            <p className="faq-text">Most medical centers offer charity programs, counseling, and
                                                financial assistance for those in need. Non-Muslims are welcome to visit
                                                mosques. They should dress modestly and remove their shoes upon entering.
                                            </p>
                                        </div>
                                    </div>
                                </div>



                                <div className="accordion-card  wow fadeInUp" data-wow-delay=".8s">
                                    <div className="accordion-header" id="collapse-item-5">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-5" aria-expanded="false" aria-controls="collapse-5">5. How does the treatment programme work?</button>
                                    </div>
                                    <div id="collapse-5" className="accordion-collapse collapse " aria-labelledby="collapse-item-5" data-bs-parent="#faqAccordion3">
                                        <div className="accordion-body">
                                            <p className="faq-text">Most medical centers offer charity programs, counseling, and
                                                financial assistance for those in need. Non-Muslims are welcome to visit
                                                mosques. They should dress modestly and remove their shoes upon entering.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> */}

      <Footer />
    </>
  );
}
